/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type { ServicesAppLayoutWithProjectContext as ServicesAppLayoutWithProjectContextType } from '@jira/spa-apps__servicedesk-services-with-project-context/src/ServicesAppLayoutWithProjectContext.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyServicedeskServicesWithProjectContext: LazyComponent<() => React.JSX.Element> =
	lazyForPaint<typeof ServicesAppLayoutWithProjectContextType>(
		() =>
			import(
				/* webpackChunkName: "async-servicedesk-services-with-project-context", jiraSpaEntry: "async-servicedesk-services-with-project-context" */ '@jira/spa-apps__servicedesk-services-with-project-context/src/ServicedeskServicesWithProjectContext.tsx'
			),
	);

const AsyncServicedeskServicesWithProjectContext = (): React.JSX.Element => (
	<LazyPage
		Page={LazyServicedeskServicesWithProjectContext}
		pageId="spa-apps/servicedesk/services"
		shouldShowSpinner
	/>
);

export default AsyncServicedeskServicesWithProjectContext;
